import React from 'react'

import DataTypeIcon from 'components/common/DataTypeIcon'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'

import ToggleButton from 'components_new/molecules/ToggleButton'

import Condition from './Condition'

const Filters = ({
  chosenAttributes,
  filterData,
  setFilterData,
  title,
  addText
}) => {
  const attributeOptions = Object.values(chosenAttributes)
    .sort((a, b) =>
      a.outputAttributeName?.toLowerCase() <
      b.outputAttributeName?.toLowerCase()
        ? -1
        : 1
    )
    .map((attribute) => ({
      label: (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5
          }}
        >
          <DataTypeIcon type={attribute.type} />
          <Text>{attribute.outputAttributeName}</Text>
          <Text color="text.secondary">{attribute.tableName}</Text>
        </Box>
      ),
      value: attribute.outputAttributeId,
      type: attribute.type
    }))

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {title ? title : <p className={'bold'}>Villkor</p>}
      {filterData.conditions.map((condition, index) => (
        <>
          <Condition
            remove={() => {
              const updatedConditions = [...filterData.conditions]

              updatedConditions.splice(index, 1)
              setFilterData({
                ...filterData,
                conditions: updatedConditions
              })
            }}
            attributeOptions={attributeOptions}
            condition={condition}
            updateCondition={(newCondition) => {
              setFilterData({
                ...filterData,
                conditions: filterData.conditions.map((cond, i) =>
                  i === index ? newCondition : cond
                )
              })
            }}
            key={`element-condition-${index}`}
          />
          {index > 0 && filterData.conditions.length > 1 && (
            <ToggleButton
              items={[
                { title: 'OCH', value: 'AND' },
                { title: 'ELLER', value: 'OR' }
              ]}
              size="small"
              value={filterData.conditions[index].conjunctiveOperator}
              onChange={(value) => {
                const updatedConditions = [...filterData.conditions]

                updatedConditions[index].conjunctiveOperator = value
                setFilterData({
                  ...filterData,
                  conditions: updatedConditions
                })
              }}
            />
          )}
        </>
      ))}
      <Button
        fullWidth
        key={'add-area'}
        onClick={() => {
          const newCondition = { type: null, conjunctiveOperator: 'AND' }
          const updatedConditions = [...filterData.conditions, newCondition]

          if (updatedConditions.length > 1) {
            updatedConditions[
              filterData.conditions.length - 2
            ].conjunctiveOperator = 'AND'
          }

          setFilterData({
            ...filterData,
            conditions: updatedConditions
          })
        }}
        size="large"
        startIcon={<Icon name="AddCircleOutlineOutlined" />}
        variant="text"
      >
        {addText ?? 'Lägg till'}
      </Button>
    </Box>
  )
}

export default Filters
